import { render, staticRenderFns } from "./DetailClaim.vue?vue&type=template&id=25b5d63d"
import script from "./DetailClaim.vue?vue&type=script&lang=ts"
export * from "./DetailClaim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports